import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from "react";
import { connect } from "react-redux";
import Moment from "moment";
import { setPageTitle } from "actions/header";
import { getUserAssessmentDates } from "helpers/user";
import { getGuardianStudentAssessmentsForProgress } from 'actions/sections';
import DatePickers from "./Partials/DatePickers";
import GroupFilter from "./Partials/GroupFilter";
import StudyPlan from "../StudyPlan/StudyPlan";
import AdditionalAdjustments from "./Partials/AdditionalAdjustments";
import MentorGoalOverview from "./Partials/MentorGoalOverview";
import UserAssessments from "./Partials/UserAssessments";
import { Spinner } from "components/UI";
import { Button, Tabs, Tab, translate } from "@haldor/ui";
import { COMPULSORY_SCHOOL, PRESCHOOL, UPPER_SECONDARY_EDUCATION } from "constants/schoolTypes";
var StudentProgress = /*#__PURE__*/function (_Component) {
  function StudentProgress(props) {
    var _this;
    _classCallCheck(this, StudentProgress);
    _this = _callSuper(this, StudentProgress, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      var _this$state = _this.state,
        start = _this$state.start,
        end = _this$state.end;
      _this.props.getGuardianStudentAssessmentsForProgress(_this.props.activeStudent.id, start, end).then(function () {
        _this.setState({
          loading: false
        });
      });
      if (!_this.props.noTitle) {
        _this.props.setPageTitle(_this.props.translate("Progress"));
      }
    });
    _defineProperty(_this, "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var progressSections = nextProps.progressSections;
      if (progressSections != null && progressSections.length > 0) {
        progressSections = progressSections.sort(function (a, b) {
          if (a.title.toLowerCase() < b.title.toLowerCase()) {
            return -1;
          }
          if (a.title.toLowerCase() > b.title.toLowerCase()) {
            return 1;
          }
          return 0;
        });
      }
    });
    _defineProperty(_this, "onDateChange", function (_ref) {
      var start = _ref.start,
        end = _ref.end;
      if (start == "Invalid date") {
        start = Moment().subtract(1, "years");
      }
      if (end == "Invalid date") {
        end = Moment().add(1, "years");
      }
      localStorage.setItem("assessment-start-date", start);
      localStorage.setItem("assessment-end-date", end);
      _this.setState({
        start: start,
        end: end
      });
    });
    _defineProperty(_this, "updateDates", function () {
      var _this$state2 = _this.state,
        start = _this$state2.start,
        end = _this$state2.end;
      _this.setState({
        loading: true,
        currentStart: start,
        currentEnd: end
      });
      _this.props.getGuardianStudentAssessmentsForProgress(_this.props.activeStudent.id, start, end).then(function () {
        _this.setState({
          loading: false
        });
      });
    });
    _defineProperty(_this, "onGroupChange", function (groupId) {
      var group = _this.props.progressSections.find(function (g_object) {
        return g_object.id == groupId;
      });
      _this.props.progressSections.map(function (group) {
        group.open = false;
        group.hidden = false;
      });
      if (group != null) {
        _this.props.progressSections.map(function (group) {
          if (groupId != group.id) {
            group.hidden = true;
          }
        });
      } else {
        _this.props.progressSections.map(function (group) {
          group.open = false;
          group.hidden = false;
          return group;
        });
      }
      _this.setState({
        selectedGroupId: groupId
      }, function () {
        if (group != null) {
          group.open = true;
          group.hidden = false;
        }
      });
    });
    _this.state = {
      loading: true,
      student: null,
      selectedGroupId: 0,
      start: getUserAssessmentDates().start,
      end: getUserAssessmentDates().end,
      currentStart: getUserAssessmentDates().start,
      currentEnd: getUserAssessmentDates().end
    };
    return _this;
  }
  _inherits(StudentProgress, _Component);
  return _createClass(StudentProgress, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var differentProps = this.props !== nextProps;
      var differentState = this.state !== nextState;
      if (differentProps || differentState) {
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        progressSections = _this$props.progressSections,
        translate = _this$props.translate;
      var hasPreschool = this.props.activeStudent.schools.find(function (school) {
        return school.type == PRESCHOOL;
      }) != null;
      var hasCompulsory = this.props.activeStudent.schools.find(function (school) {
        return school.type == COMPULSORY_SCHOOL;
      }) != null;
      var hasUpperSecondary = this.props.activeStudent.schools.find(function (school) {
        return school.type == UPPER_SECONDARY_EDUCATION;
      }) != null;
      return /*#__PURE__*/React.createElement("div", {
        className: "page progress"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: "2rem"
        },
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement(DatePickers, {
        startDate: this.state.start,
        endDate: this.state.end,
        onChange: this.onDateChange
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, /*#__PURE__*/React.createElement(GroupFilter, {
        onChange: this.onGroupChange,
        sections: progressSections
      }))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1em"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.updateDates,
        disabled: this.state.loading
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, null) : null, translate("Update"))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement(Tabs, null, hasCompulsory || hasUpperSecondary ? /*#__PURE__*/React.createElement(Tab, {
        title: translate("Assessments"),
        route: "knowledge"
      }, /*#__PURE__*/React.createElement(UserAssessments, {
        studentId: this.props.activeStudent.id,
        start: this.state.currentStart,
        end: this.state.currentEnd,
        sectionId: this.state.selectedGroupId != 0 ? this.state.selectedGroupId : null
      })) : null, hasPreschool ? /*#__PURE__*/React.createElement(Tab, {
        title: translate("Goals"),
        route: "goals"
      }, /*#__PURE__*/React.createElement(MentorGoalOverview, {
        userId: this.props.activeStudent.id,
        start: this.state.start,
        end: this.state.end
      })) : null, this.props.activeStudent != null && this.props.activeStudent.services.verdicts && (hasCompulsory || hasUpperSecondary) ? /*#__PURE__*/React.createElement(Tab, {
        title: translate("Evaluations"),
        route: "verdicts"
      }, /*#__PURE__*/React.createElement(StudyPlan, {
        start: this.state.start,
        end: this.state.end
      })) : null, this.props.activeStudent != null && this.props.activeStudent.services.additionalAdjustments ? /*#__PURE__*/React.createElement(Tab, {
        title: translate("Additional adjustments"),
        route: "adjustments"
      }, /*#__PURE__*/React.createElement(AdditionalAdjustments, null)) : null));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    progressSections: state.groups.progressSections,
    progressAssessmentStats: state.groups.progressAssessmentStats,
    studentOverview: state.groups.studentOverview,
    studentAssessments: state.groups.studentAssessments,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  getGuardianStudentAssessmentsForProgress: getGuardianStudentAssessmentsForProgress
})(StudentProgress);